/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_HybridInputs */

const en_val_hybrid = /** @type {(inputs: Val_HybridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hybrid`)
};

const es_val_hybrid = /** @type {(inputs: Val_HybridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Híbrido`)
};

const fr_val_hybrid = /** @type {(inputs: Val_HybridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hybride`)
};

const de_val_hybrid = /** @type {(inputs: Val_HybridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hybrid`)
};

const ja_val_hybrid = /** @type {(inputs: Val_HybridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ハイブリッド`)
};

const zh_val_hybrid = /** @type {(inputs: Val_HybridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`油电混合`)
};

const ar_val_hybrid = /** @type {(inputs: Val_HybridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هجين`)
};

const id_val_hybrid = /** @type {(inputs: Val_HybridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hibrida`)
};

const it_val_hybrid = /** @type {(inputs: Val_HybridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ibrido`)
};

const ru_val_hybrid = /** @type {(inputs: Val_HybridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Гибрид`)
};

const pt_val_hybrid = /** @type {(inputs: Val_HybridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Híbrido`)
};

const ko_val_hybrid = /** @type {(inputs: Val_HybridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`하이브리드`)
};

/**
* | output |
* | --- |
* | "Hybrid" |
*
* @param {Val_HybridInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_hybrid = /** @type {((inputs?: Val_HybridInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_HybridInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_hybrid(inputs)
	if (locale === "es") return es_val_hybrid(inputs)
	if (locale === "fr") return fr_val_hybrid(inputs)
	if (locale === "de") return de_val_hybrid(inputs)
	if (locale === "ja") return ja_val_hybrid(inputs)
	if (locale === "zh") return zh_val_hybrid(inputs)
	if (locale === "ar") return ar_val_hybrid(inputs)
	if (locale === "id") return id_val_hybrid(inputs)
	if (locale === "it") return it_val_hybrid(inputs)
	if (locale === "ru") return ru_val_hybrid(inputs)
	if (locale === "pt") return pt_val_hybrid(inputs)
	return ko_val_hybrid(inputs)
});